// extracted by mini-css-extract-plugin
export default {"adminPanel":"AdminPanel_adminPanel__5m5Xq"};